module.exports = __webpack_public_path__ + "img/gsndc2782_1.a3dd7c6a.svg";